import { createTheme, ThemeOptions } from '@mui/material';
import { legacyThemeOptions } from './material-custom.legacy';
import { newUiThemeOptions } from './material-custom.new-ui';
import { isNewUi } from './ui-version';

export const greycroftTheme: ThemeOptions = createTheme(isNewUi ? newUiThemeOptions : legacyThemeOptions);
